<div class="component-viewer">
    <h2>Prize Details</h2>
    <mat-card>
        <mat-card-content>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-3">
                        <div>Name</div>
                    </div>
                    <div class="col-3">
                        <div>Description</div>
                    </div>
                    <div class="col-3">
                        <div>Value</div>
                    </div>
                    <div class="col-3">
                        <div>Expense Cost</div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-3">
                        <div>{{prize?.name}}</div>
                    </div>
                    <div class="col-3">
                        <div>{{prize?.description}}</div>
                    </div>
                    <div class="col-3">
                        <div>${{prize?.value}}</div>
                    </div>
                    <div class="col-3">
                        <div>${{prize?.expenseCost}}</div>
                    </div>
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-1">
                        <button mat-raised-button [routerLink]="['/outing-management/administration/prize/edit/', id]">
                            Edit <mat-icon>edit</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </mat-card-actions>
    </mat-card>
</div>